export default __webpack_public_path__ + "static/media/swifta.2194ec62.svg";